import { hasFilters } from '@/utils';
import { useTranslations } from 'next-intl';

export const ShowBar = ({ openModal, dataTestId = '', searchState }) => {
  const t = useTranslations();

  return (
    <button
      id="sub-btn"
      onClick={openModal}
      className="btn relative btn-second btn-sm btn-icon max-sm:self-center sm:self-end gap-2 sm:!pr-2.5 sm:focus:ring-primary-800 sm:focus:text-primary-800"
      data-testid={dataTestId}
    >
      <i className="icon-setting_vert text-[24px]" aria-hidden="true" />
      <span className="max-sm:hidden">{t('listings.filters.bar.show')}</span>
      {hasFilters(searchState) && (
        <span className="absolute top-1 right-1 w-2 h-2 bg-rose-600 rounded-10 flex-col justify-center items-center inline-flex" />
      )}
    </button>
  );
};
